import { ProgramType } from 'types';

import { EnergyBackupSystemDesign } from '../SystemDesign/energyBackup/EnergyBackupSystemDesign';
import { GeneratorSystemDesign } from '../SystemDesign/generator/GeneratorSystemDesign';
import { GeothermalSystemDesign } from '../SystemDesign/geothermal/GeothermalSystemDesign';
import { HVACSystemDesign } from '../SystemDesign/hvac/HVACSystemDesign';
import { WaterHeaterSystemDesign } from '../SystemDesign/waterHeater/WaterHeaterSystemDesign';

import PVSystem from './PVSystem';

export const SystemDesignFactory = ({ programType }: { programType: ProgramType }) => {
  switch (programType) {
    case ProgramType.hvac:
      return <HVACSystemDesign />;
    case ProgramType.waterHeater:
      return <WaterHeaterSystemDesign />;
    case ProgramType.generator:
      return <GeneratorSystemDesign />;
    case ProgramType.geothermal:
      return <GeothermalSystemDesign />;
    case ProgramType.energyBackup:
      return <EnergyBackupSystemDesign />;
    case ProgramType.solar:
    case ProgramType.doePr:
    case ProgramType.newCommunity:
    case ProgramType.newHomes:
    case ProgramType.consumerSolar:
      return <PVSystem />;
    default:
      return null;
  }
};
